import { render } from "./level-connection-icon.vue?vue&type=template&id=dd9341fe"
const script = {}

import exportComponent from "/builds/tumeda/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__